import { Helmet } from 'react-helmet'

// Components
import SEO from 'components/base/seo'
import Header from 'components/interestform/header'
import InterestForm from '../components/interestform'

// Utils
import styles from './interestform.css'

const InterestFormPage = () => {
  const title = 'Interest Form'
  const description = 'Sign up to make your tracks available on the Tracklib library'
  const headerTitle = 'Artists and labels'

  return (
    <>
      <Helmet>
        <body data-theme="light" />
      </Helmet>
      <SEO title={title} description={description} />
      <div className={styles.interestFormPage}>
        <Header headerTitle={headerTitle} />
        <InterestForm />
      </div>
    </>
  )
}

export default InterestFormPage
